import { spaceMixin } from '@zillow/constellation';
import styled from 'styled-components';

export const StyledMessageListItem = styled.li`
  margin: ${spaceMixin('sm')} 0;
  width: 100%;
  list-style: none;
`;
